import { render, staticRenderFns } from "./Fund_morePop.vue?vue&type=template&id=2705da36&"
import script from "./Fund_morePop.vue?vue&type=script&lang=js&"
export * from "./Fund_morePop.vue?vue&type=script&lang=js&"
import style0 from "./Fund_morePop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports